
import ResponsiveDialog from "../dialogs/responsive-dialog.vue";
import OrderDetailsPriceBreakup from "../reciever/order-details-price-breakup.vue";

export default {
  components: { ResponsiveDialog, OrderDetailsPriceBreakup },
  props: {
    dialog: false
  }
};
